import React, { Component } from 'react';
import { ListGroup, ListGroupItem, Collapse } from 'reactstrap';

import quellen from '../../data/quellen';
import implementedQuellen from '../../data/implementedQuellen';


class Category extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false
    }
  }
  render(){
    return (
      <React.Fragment>
        <ListGroupItem tag="button" action className="text-left font-weight-bold d-flex justify-content-between align-items-center" onClick={() => this.setState({isOpen: !this.state.isOpen})}>
          <div><i className="fas fa-archive mr-3 text-secondary"></i>{this.props.name}</div>
          <i className={ 'text-muted ' + (this.state.isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down')}></i>
        </ListGroupItem>
        <Collapse isOpen={this.state.isOpen}>
          { this.props.items.sort().map((item, index) =>
            <ListGroupItem key={index}>
              <small className="d-flex justify-content-start align-items-center">
                <i className="fas fa-university mr-3 text-secondary"></i>
                <span>{item}</span>
                { (implementedQuellen.filter(cat => (cat.name === this.props.name && cat.items.indexOf(item) !== -1)).length>0 ? <i className="far fa-check-circle ml-auto text-primary" title="In der Datebank"></i> : <i className="far fa-clock ml-auto text-secondary" title="In Planung"></i> ) }
              </small>
            </ListGroupItem> ) }
        </Collapse>
      </React.Fragment>
    )
  }
}


class SourceList extends Component {
  render(){
    const dark = (this.props.bg === "secondary");
    return (
      <React.Fragment>
        { this.props.legend &&
        <div className="d-flex justify-content-center align-items-stretch py-3">
          <div className={ (dark ? 'text-white ' : '') + "px-4"}><small><i className={ (dark ? 'text-white' : 'text-primary') + " far fa-check-circle ml-auto mr-2"} title="In der Datebank"></i>In der Datebank</small></div>
          <div className={ (dark ? 'text-white ' : '') + "px-4"}><small><i className={ (dark ? 'text-white' : 'text-secondary') + " far fa-clock ml-auto mr-2"} title="In Planung"></i>In Planung</small></div>
        </div>
        }
        <ListGroup className={this.props.className + " rounded"}>
          { quellen.sort((a,b) => a.name > b.name).map((category, index) => <Category key={index} {...category} /> ) }
        </ListGroup>
      </React.Fragment>
    );
  }
}

export default SourceList;



// WEBPACK FOOTER //
// ./src/components/ui-elements/SourceList.js